var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23181_366978)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23181_366978",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 59,
    height: 59
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0052 58.1069C45.0243 58.1069 58.0104 45.1208 58.0104 29.1017C58.0104 13.0826 45.0243 0.0964966 29.0052 0.0964966C12.9861 0.0964966 0 13.0826 0 29.1017C0 45.1208 12.9861 58.1069 29.0052 58.1069Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23181_366978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8412 8.94653C21.8412 8.94653 17.0114 13.6515 12.7775 13.9819C7.63965 14.3829 -2.38289 15.467 -13.3593 25.8375C-24.1713 36.0742 -25.6017 44.5304 -22.623 50.5066C-18.5096 60.8968 12.5507 59.3894 25.4775 40.52C38.4044 21.6505 21.8412 8.94653 21.8412 8.94653Z",
    fill: "#CCD3DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4894 8.30127C24.5732 6.34103 27.5737 5.301 31.3926 5.7957C36.0201 6.39507 41.3239 10.2762 39.6545 19.8748C37.3062 33.3973 25.2789 30.6549 20.8243 25.6055C17.2088 21.5004 17.7539 11.7964 22.4894 8.30127Z",
    fill: "#CCD3DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3699 20.3651C25.3699 20.3651 26.7755 12.1205 33.7254 12.1205C38.9931 12.1205 40.1737 18.2005 39.5337 24.7504C38.8936 31.3004 36.4544 35.3667 32.108 33.879C27.5323 32.3051 24.985 29.7912 24.2973 26.1648C24.2973 26.1648 20.7164 25.3929 21.4646 21.5466C22.2863 17.2949 25.3699 20.3651 25.3699 20.3651Z",
    fill: "#F4F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3254 40.0399C37.3254 40.0399 30.2612 37.7092 31.1867 32.9703L24.6995 25.2863C24.6995 25.2863 23.5188 36.9288 19.6913 38.7614C19.6913 38.7614 21.9921 47.7649 26.4813 48.5583C30.9704 49.3518 36.5124 43.33 37.3254 40.0399Z",
    fill: "#F4F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0999 33.3095C31.0999 33.3095 28.0725 31.5373 27.0475 30.1747C26.0225 28.8121 26.6497 33.1198 27.0908 33.9952C28.6391 37.0675 30.8764 36.4383 32.5415 37.2705C31.2827 35.634 31.0999 34.3752 31.0999 33.3095Z",
    fill: "#DEE5EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6561 115.757C66.6561 115.757 68.2926 97.1914 63.0055 77.3017C60.5962 68.238 56.0028 58.419 52.0535 52.8801C47.3168 47.2153 44.5005 43.9423 37.0592 39.5733C35.1896 40.9404 32.9229 41.6603 30.6047 41.6233C28.9675 41.5892 23.4576 41.3164 20.8715 38.8317C19.6351 38.8168 20.9982 38.436 19.8271 38.8318C2.07737 49.9085 -1.32151 61.8179 -8.24516 79.9452C-8.24516 79.9452 -9.93508 88.4192 -11.1405 98.1577L54.4309 111.208C54.1958 106.946 53.1486 89.8981 52.8878 85.7768C52.8878 85.7768 51.0884 107.89 56.5299 107.669C68.1353 107.2 62.0482 139.372 66.6561 115.757Z",
    fill: "#EAF0F4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23181_366978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white",
    transform: "translate(0 0.0964966)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarFemale);
export default __webpack_public_path__ + "static/media/avatar-female.6e8506a432968530ebfff8335f86d324.svg";
export { ForwardRef as ReactComponent };